// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wordLevelChunk__AuKcs {
  display: inline;
  line-height: 1.8;
}

.styles_word__sXnSn {
  display: inline-block;
  padding: 2px 4px;
  margin: 0 1px;
  cursor: pointer;
  transition: all 0.15s ease;
  border-radius: 3px;
  position: relative;
}
.styles_word__sXnSn:hover {
  background-color: rgba(33, 150, 243, 0.15);
  transform: translateY(-1px);
}
.styles_word__sXnSn.styles_wordPlaying__jspQr {
  background-color: #2196f3;
  color: white;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);
  transform: translateY(-1px) scale(1.05);
  animation: styles_pulse__S9wOP 0.5s ease-in-out;
}

@keyframes styles_pulse__S9wOP {
  0% {
    transform: translateY(-1px) scale(1);
  }
  50% {
    transform: translateY(-1px) scale(1.08);
  }
  100% {
    transform: translateY(-1px) scale(1.05);
  }
}
.styles_word__sXnSn.styles_wordPlaying__jspQr::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: white;
  animation: styles_slideIn__jyEar 0.3s ease-out;
}

@keyframes styles_slideIn__jyEar {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.styles_segmentGroup__mGftK {
  margin-bottom: 1rem;
}
.styles_segmentGroup__mGftK h4 {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1976d2;
}

.styles_chunk__HxC4i {
  display: inline;
  line-height: 1.6;
}
.styles_chunk__HxC4i.styles_selected__gjZav {
  background-color: rgba(255, 235, 59, 0.3);
}

.styles_chunkWrapper__vUVqo {
  position: relative;
  display: inline;
}
.styles_chunkWrapper__vUVqo .styles_image__pLhZl {
  cursor: pointer;
  margin-left: 8px;
  width: 16px;
  height: 16px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.styles_chunkWrapper__vUVqo .styles_image__pLhZl:hover {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/Transcript/SegmentGroup/styles.module.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;AAFF;AAIE;EACE,0CAAA;EACA,2BAAA;AAFJ;AAOE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,uCAAA;EACA,+CAAA;AALJ;;AASA;EACE;IACE,oCAAA;EANF;EAQA;IACE,uCAAA;EANF;EAQA;IACE,uCAAA;EANF;AACF;AAUA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,8CAAA;AARF;;AAWA;EACE;IACE,oBAAA;EARF;EAUA;IACE,oBAAA;EARF;AACF;AAYA;EACE,mBAAA;AAVF;AAYE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AAVJ;;AAcA;EACE,eAAA;EACA,gBAAA;AAXF;AAaE;EACE,yCAAA;AAXJ;;AAgBA;EACE,kBAAA;EACA,eAAA;AAbF;AAeE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;AAbJ;AAeI;EACE,UAAA;AAbN","sourcesContent":["// Existing styles...\n\n// Word-level specific styles (v2 - cache buster)\n.wordLevelChunk {\n  display: inline;\n  line-height: 1.8;\n}\n\n.word {\n  display: inline-block;\n  padding: 2px 4px;\n  margin: 0 1px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border-radius: 3px;\n  position: relative;\n  \n  &:hover {\n    background-color: rgba(33, 150, 243, 0.15);\n    transform: translateY(-1px);\n  }\n\n\n  // Currently playing word (bright highlight)\n  &.wordPlaying {\n    background-color: #2196f3;\n    color: white;\n    font-weight: 500;\n    box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);\n    transform: translateY(-1px) scale(1.05);\n    animation: pulse 0.5s ease-in-out;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: translateY(-1px) scale(1);\n  }\n  50% {\n    transform: translateY(-1px) scale(1.08);\n  }\n  100% {\n    transform: translateY(-1px) scale(1.05);\n  }\n}\n\n// Optional: Add a subtle underline animation for the playing word\n.word.wordPlaying::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: white;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    transform: scaleX(0);\n  }\n  to {\n    transform: scaleX(1);\n  }\n}\n\n// Keep existing segment-level styles intact\n.segmentGroup {\n  margin-bottom: 1rem;\n  \n  h4 {\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n    color: #1976d2;\n  }\n}\n\n.chunk {\n  display: inline;\n  line-height: 1.6;\n  \n  &.selected {\n    background-color: rgba(255, 235, 59, 0.3);\n  }\n  \n}\n\n.chunkWrapper {\n  position: relative;\n  display: inline;\n  \n  .image {\n    cursor: pointer;\n    margin-left: 8px;\n    width: 16px;\n    height: 16px;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n    \n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wordLevelChunk": `styles_wordLevelChunk__AuKcs`,
	"word": `styles_word__sXnSn`,
	"wordPlaying": `styles_wordPlaying__jspQr`,
	"pulse": `styles_pulse__S9wOP`,
	"slideIn": `styles_slideIn__jyEar`,
	"segmentGroup": `styles_segmentGroup__mGftK`,
	"chunk": `styles_chunk__HxC4i`,
	"selected": `styles_selected__gjZav`,
	"chunkWrapper": `styles_chunkWrapper__vUVqo`,
	"image": `styles_image__pLhZl`
};
export default ___CSS_LOADER_EXPORT___;
